import TextInputField from "../InputField";
import type { TextInputFieldProps } from "../InputField/ClientInputField";

const PasswordField = ({
  id = "password",
  label = "Passord",
  type = "password",
  valueMissingMessage = "Vennligst legg inn et passord",
  typeMismatchMessage = "Vennligst legg inn et gyldig passord",
  required = true,
  value,
  onChange,
  ...props
}: Partial<TextInputFieldProps>) => {
  return (
    <TextInputField
      id={id}
      label={label}
      type={type}
      valueMissingMessage={valueMissingMessage}
      typeMismatchMessage={typeMismatchMessage}
      required={required}
      value={value}
      onChange={onChange}
      {...props}
    />
  );
};

export default PasswordField;
